var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"shape-canvas",attrs:{"id":_vm.canvId}})
}
var staticRenderFns = []

export { render, staticRenderFns }